import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "v-row titled-pane" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", { class: "close-icon" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0 0 L16 16 M16 0 L0 16",
    style: {"pointer-events":"none"}
  })
], -1)
const _hoisted_4 = { class: "v-column content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.innerVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: _ctx.id,
          class: _normalizeClass(["modal", {opened: _ctx.opened}]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
          onTransitionend: _cache[1] || (_cache[1] = ($event: any) => (_ctx.opened ? null : _ctx.$emit("update:visible", _ctx.innerVisible = false)))
        }, [
          _createElementVNode("div", {
            class: "v-column modal-content",
            style: _normalizeStyle({width: _ctx.width, height: _ctx.height})
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
              _hoisted_3
            ]),
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ], 4)
        ], 42, _hoisted_1))
      : _createCommentVNode("", true)
  ]))
}